<template>
   
    <gridComponent
        :loader="loader"
        :items="items"
        :itemsData="itemsData"
        :headers="headers"
        :colonneWidth="colonneWidth"
        :GetFunction="fetchDeliveryPersons"
    >

        <template v-slot:[SlotsFilters.Filter0]="{ index }">
            <ColumnFilter
                :title="$t('Delivery.fullName')"
                :Filter="filters.SearchFullName"
                :getList="fetchDeliveryPersons"
                @cancel="filters.SearchFullName = null"
                :index="index"
            >
                <template v-slot:input>
                    <v-text-field
                        v-model="filters.SearchFullName"
                        id="fullName"
                        variant="outlined"
                        maxlength="50"
                        hide-details
                    ></v-text-field>
                </template>
            </ColumnFilter>
        </template>


        <template v-slot:[SlotsFilters.Filter1]="{ index }">
            <ColumnFilter
                :title="$t('Delivery.phone')"
                :Filter="filters.SearchPhone"
                :getList="fetchDeliveryPersons"
                @cancel="filters.SearchPhone = null"
                :index="index"
            >
                <template v-slot:input>
                    <v-text-field
                        v-model="filters.SearchPhone"
                        id="phone"
                        variant="outlined"
                        maxlength="15"
                        hide-details
                    ></v-text-field>
                </template>
            </ColumnFilter>
        </template>

        

        <template v-slot:[SlotsFilters.Filter2]="{ index }">
            <ColumnFilter
                :title="$t('Delivery.status')"
                :Filter="filters.SearchIsActive"
                :getList="fetchDeliveryPersons"
                @cancel="filters.SearchIsActive = null"
                :index="index"
            >
                <template v-slot:input>
                    <v-select
                        v-model="filters.SearchIsActive"
                        :items="[true, false]"
                        :item-title="item => (item ? $t('common.active') : $t('common.inactive'))"
                        variant="outlined"
                        hide-details
                    ></v-select>
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:[SlotsItems.item0]="{ item }">{{ item.fullName }}</template>
        <template v-slot:[SlotsItems.item1]="{ item }">{{ item.phone }}</template>
        <template v-slot:[SlotsItems.item2]="{ item }">
            <StatusButton
                :title="getStatusLabel(item.isActive)"
                :color="getStatusColor(item.isActive)"
            />
        </template>
        <template v-slot:edit="{ item, index }">
            <DeliveryPersonsActionMenu :Id="index" v-bind:idBrand="item.deliveryPersonId"
                v-bind:getBrand="item" v-bind:getBrandListAfterDelete="BrandsList" :companyId ="companyId"
                :isDeliveryResult="isDeliveryResult"
                />
        </template>
    </gridComponent>
</template>


<script>
import { getBrands } from '@/api/index';
import GridComponent from '@/genericComponent/gridComponent.vue';
import ColumnFilter from '@/genericComponent/ColumnFilter.vue';
import StatusButton from '@/genericComponent/StatusButton.vue';
import DeliveryPersonsActionMenu from './DeliveryPersonsActionMenu.vue'
import {  getAllCategories , isSupplier,
    idSupplier,getAllSuppliersForProducts, getDeliveryPersonsByCompanyId   } from "@/api/index";
export default {
    components: {  StatusButton, GridComponent, ColumnFilter , DeliveryPersonsActionMenu  },
    props: {
        isDeliveryResult: {
            type: Boolean,
            required: true,
            default: false,
        },
        companyId: {
            type: String,
            required: true,
        },
    },

    mounted() {
        this.fetchDeliveryPersons();
     
        this.emitter.emit('remise-search-at-null');
        this.emitter.on('event-test', (event) => {
            this.search = event;
        });
    },
    unmounted() {
        this.emitter.off('event-test');
        this.emitter.emit('remise-search-at-null');
    },
    data() {
        return {
            loader: true,
            page: 1,
            PageSize: 10,
            items: {},
            itemsData: {},
            filters: {
                SearchDeliveryPersonId: null,
                SearchFullName: null,
                SearchPhone: null,
                SearchIsActive: null,
            },
            search: null,
            filterMenuitems: [1, 3, 4],
            brandName: null,
            FieldCategoryId : [],
            FieldCreatedDateFrom : null ,
            FieldCreatedDateTo : null,
            FieldSupplierId : null,
            SortedBy: null,
            SortingType: null,
            localShowFilterDialog: this.showFilterDialog,
            MySupplier :null,
            item:null,
            suppliers : [],
            categories: [],
        }
    },
    methods: {
        fetchDeliveryPersons(page = this.page) {
            if (!this.companyId) {
                console.error("companyId is not defined.");
                return;
            }

            const params = {
                PageNumber: page,
                PageSize: this.PageSize,
                SearchDeliveryPersonId: this.filters.SearchDeliveryPersonId,
                SearchFullName: this.filters.SearchFullName,
                SearchPhone: this.filters.SearchPhone,
                SearchIsActive: this.filters.SearchIsActive,
                SortedBy: this.SortedBy,
                SortingType: this.SortingType,
            };

            getDeliveryPersonsByCompanyId(this.companyId, params)
                .then((response) => {
                    this.items = response.data.items;
                    
                    this.itemsData.numberOfPage = response.data.totalPages;
                this.itemsData.totalItemsCount = response.data.totalCount;
                this.itemsData.pageNumber = response.data.pageNumber;
                this.itemsData.hasPreviousPage = response.data.hasPreviousPage;
                this.itemsData.hasNextPage = response.data.hasNextPage;
                    this.loader = false;
                })
                .catch((error) => {
                    console.error('Error fetching delivery persons:', error);
                });
        },
       
         async fetchCategoriesAndSuppliers  ()  {
    try {
        const [categoriesResponse, suppliersResponse] = await Promise.all([
            getAllCategories(),
            getAllSuppliersForProducts(),
        ]);
        this.categories = categoriesResponse.data;
        this.suppliers = suppliersResponse.data;

        if (isSupplier()) {
            this.MySupplier = idSupplier();
            this.supplierId = this.MySupplier;
        }
    } catch (error) {
        console.error("Error fetching categories or suppliers:", error);
      }
    },
    getStatusLabel(isActif) {
        return isActif ? this.$t('common.active') : this.$t('common.inactive');
    },
    getStatusColor(isActif) {
        return isActif ? '#3BBAFF' : '#F25C5C';
    },
       
       
        BrandsList: function (page) {
            if (page) { this.page = page }
            getBrands(this.page, this.PageSize, this.brandName, this.FieldCategoryId, this.FieldSupplierId,this.FieldCreatedDateFrom,this.FieldCreatedDateTo ,this.SortedBy, this.SortingType).then((response) => {
                this.items = response.data.items;
                this.itemsData.numberOfPage = response.data.totalPages;
                this.itemsData.totalItemsCount = response.data.totalCount;
                this.itemsData.pageNumber = response.data.pageNumber;
                this.itemsData.hasPreviousPage = response.data.hasPreviousPage;
                this.itemsData.hasNextPage = response.data.hasNextPage;
                this.loader = false;
            });
        },
        handleCancel() {
            this.localShowFilterDialog = false;
        },
        handleConfirm(filteredParams) {
            this.brandName = filteredParams.BrandName;
            this.FieldCategoryId = filteredParams.IdCategories;
            this.FieldSupplierId = filteredParams.supplierId;
            this.FieldCreatedDateFrom = filteredParams.CreatedFrom;
            this.FieldCreatedDateTo = filteredParams.CreatedTo;
            this.BrandsList();
            this.localShowFilterDialog = false;
        },
    },
    watch: {
        showFilterDialog(value) {
            this.localShowFilterDialog = value;
        },
    },
    computed: {
         flattenedCategories () {
    const flatten = (cats, parentId = null, level = 0) => {
        return cats.reduce((acc, category) => {
            if (category.parent_category_id === parentId) {
                const flatCategory = {
                    ...category,
                    name: "  ".repeat(level) + category.name,
                };
                acc.push(flatCategory);
                acc.push(...flatten(cats, category.categoryId, level + 1));
            }
            return acc;
        }, []);
    };
    return flatten(this.categories);
    },
    
        headers() {
            const headers = [
                this.$t('Delivery.DeliveryPerson.Name'),
                this.$t('Delivery.DeliveryPerson.Phone'),
                this.$t('Delivery.status'),
                
            ];
            return headers;
        },
        SlotsItems() {
            const items = {
                item0: 'item',
                item1: 'item',
                item2: 'item',
            }
            let i = 0;
            for (const key in items) {
                items[key] = 'item' + i;
                i = i + 1;
            }
            return items;
        },
        SlotsFilters() {
            const filters = {
                Filter0: 'Filter',
                Filter1: 'Filter',
                Filter2: 'Filter',
            }
            let i = 0;
            for (const key in filters) {
                filters[key] = 'Filter' + i;
                i = i + 1;
            }
            return filters;
        },
        colonneWidth() {
            const headers = ['15%', '15%', '20%', '15%'];
            return headers;
        },
       
    }
};
</script>

<style scoped>
.v-card-title {
    color: #001e50;
    font-size: 18px;
    line-height: 25.5px;
    font-weight: 700;
    font-family: inter;
}

.v-window .v-card-title {
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    color: #5b6d8e;
    margin-left: 12px;
    margin-bottom: 5px;
}

.slider {
    color: #667280;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    flex: content;
    pointer-events: none;
    border: none;
}
</style>
